<template>
  <div>
    <div class="mb-1">
      <p>{{message}}</p>
    </div>
    <div class="mb-5">
      <div class="bar">
        <span class="bar__circle" v-bind:style="{marginLeft: patternMargin + '%'}"></span>
        <span class="bar__low">{{ $t('drivingPattern.drivingPatternBarTextBad') }}</span>
        <span class="bar__high">{{ $t('drivingPattern.drivingPatternBarTextGood') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['result', 'message'],
  computed: {
    patternMargin: function() {
      let value = this.result;
      return this.scale(value, -10, 10, 0, 95);
    }
  },
  methods: {
    scale: (num, in_min, in_max, out_min, out_max) => {
      return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
    }
  }
};
</script>

<style lang="scss" scoped>
.bar {
  background-image: linear-gradient(90deg, red, yellow, green);
  height: 15px;
  line-height: 0;
  width: 100%;
  border: 1px solid black;
  position: relative;

  &__circle {
    background: #fff;
    border: 2px solid #0f218b;
    border-radius: 100%;
    position: relative;
    top: -5px;
    height: 21px;
    width: 21px;
    display: block;
  }

  &__low,
  &__high {
    position: absolute;
    top: 24px;
    font-size: 12px;
    font-weight: 500;
  }
  &__high {
    right: 0;
  }
  &__low {
    left: 0;
  }
}
</style>
